import Huddle from "../../img/design/huddle.png"
import WDB from "../../img/design/wdb.png"
import TBF from "../../img/design/tbf.png"
import Resource from "../../img/design/resource.png"
import CMES from "../../img/design/cmes.png"
import FEB from "../../img/design/feb.png"
import Carepath from "../../img/design/carepath.png"
import LP from "../../img/design/lp.png"
import Circles from "../../img/design/circles.png"
import CCIS from "../../img/design/ccis.png"
import HappyDrops from "../../img/work/happy-drops.png"

export const CreativeData = [
    {
        name: "Huddle",
        description: "UI/UX and brand Design at my video calling startup, Huddle",
        link: "https://www.figma.com/file/cAF9aAFA9ysf3jjAHKdzyL/huddle-Vicky-Li",
        image: Huddle,
    },
    {
        name: "WDB",
        description: "UI and Brand Design for my web development organization",
        link: "https://www.figma.com/file/fD5BvjzDHjzMEqVOFGnJkF/WDB-Mockups-Vicky-Li",
        image: WDB,
    }, 
    {
        name: "HappyDrops",
        description:
            "Selling handmade polymer clay jewelry and hand-drawn stickers and prints.",
        link: "https://www.etsy.com/shop/HappyDropsDesigns",
        image: HappyDrops,
    },
    {
        name: "TBF",
        description: "UI/UX Design for The Berkeley Forum",
        link: "https://www.figma.com/file/qvSr3onbUYfRUKAmn4wzSl/TBF-Vicky-Li",
        image: TBF,
    },
    {
        name: "Resource",
        description: "UI/UX Design for a COVID-19 resource donation platform",
        link: "https://www.figma.com/file/XqmRjzFyJS5LSUKjiKifZx/Resource-19-Mockups-Vicky-Li",
        image: Resource,
    },
    {
        name: "CMES",
        description: "UI overhaul for UC Berkeley Center for Middle Eastern Studies",
        link: "https://www.figma.com/file/gGDR64I90Wf9HrrTVznPAg/CMES-Vicky-Li",
        image: CMES,
    },
    {
        name: "FEB",
        description: "UI/UX Design for UC Berkeley’s Formula SAE team",
        link: "https://www.figma.com/file/ra3Bli59NHtgSQCCuBj91h/FEB-Vicky-Li",
        image: FEB,
    },
    {
        name: "Carepath",
        description:
            "UI/UX Design for Carepath, a platform for parents with children with a mental health disorder",
        link: "https://www.figma.com/file/MQHXQd4uWMSezroqUdh9Ht/Carepath-Vicky-LI",
        image: Carepath,
    },
    {
        name: "LP",
        description: "UI and brand design for an early stage Berkeley startup",
        link: "https://www.figma.com/file/kjgigecBg1KeHR3Zlo1wBU/Launch-Party-Mockup-Vicky-Li",
        image: LP,
    },
    {
        name: "Circles",
        description:
            "UI/UX Design for a new social media concept designed for groups",
        link: "https://www.figma.com/file/7nsaTVKl3MGqokh7J66Avw/Circles-Vicky-Li",
        image: Circles,
    },
    {
        name: "CCIS",
        description: "Rebrand and web design for UC Berkeley CCIS.",
        link: "https://www.figma.com/file/dyVjOywxkF1qmxrjwZmId2/VICKY-LI-CCIS",
        image: CCIS,
    },
]
